// extracted by mini-css-extract-plugin
module.exports = {"dotNavigationWrapper":"TXD9gK","sidePadding":"RjEM7Q","paginationDotsCustomStyle":"Mjhdmm","showDots":"kh1bhV","hideDotsOnSSR":"rjWSDF","hideDotsOnSsr":"rjWSDF"};